export default "__VITE_ASSET__9db6ba3f__"